export function contratosInRequest(params = {}) {
  return {
    type: '@contrato/CONTRATOS_IN_REQUEST',
    payload: { params },
  };
}

export function findContrato(idcontrato) {
  return {
    type: '@contrato/FIND_CONTRATO',
    payload: { idcontrato },
  };
}

export function failedRequest() {
  return {
    type: '@contrato/FAILED_REQUEST',
  };
}

export function deleteContrato(idcontrato, params) {
  return {
    type: '@contrato/DELETE_CONTRATO',
    payload: { idcontrato, params },
  };
}

export function updateContrato(contrato, params) {
  return {
    type: '@contrato/UPDATE_CONTRATO',
    payload: { contrato, params },
  };
}

export function storeContrato(contrato, params) {
  return {
    type: '@contrato/STORE_CONTRATO',
    payload: { contrato, params },
  };
}

export function successInRequest(
  contratos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@contrato/SUCCESS_IN_REQUEST',
    payload: { contratos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(contrato) {
  return {
    type: '@contrato/SUCCESS_REQUEST',
    payload: { contrato },
  };
}

export function successRemove(params) {
  return {
    type: '@contrato/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@contrato/RECORD_FILTERING',
    payload: { params },
  };
}
